import _defineProperty from "/Users/kevin/Projects/tradingblock/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _regeneratorRuntime from "/Users/kevin/Projects/tradingblock/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/Users/kevin/Projects/tradingblock/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _ from 'lodash';
import { Country, ErrorType, RE_EMAIL, State as StateEnum } from '@tradingblock/types';
import { BeneficiaryAccountType } from '@tradingblock/types';
export var RE_VALID_FIRST_NAME = /^(\s*)[a-zA-Z-]+(\s*)$/;
export var RE_VALID_TRUSTED_CONTACT_LAST_NAME = /^(\s*)[a-zA-Z-]+(\s*)$/;
export var RE_VALID_LAST_NAME = /^(\s*)[a-zA-Z-]+( [a-zA-Z-]+)?(\s*)$/;
export var RE_VALID_FIRST_NAME_WITH_NUMBERS = /^(\s*)[a-zA-Z0-9-]+(\s*)$/;
export var RE_VALID_TRUSTED_CONTACT_LAST_NAME_WITH_NUMBERS = /^(\s*)[a-zA-Z0-9-]+(\s*)$/; // PO Box addresses not allowed for home address

export var RE_PO_BOX = /^ *((#\d+)|((box|bin)[-. \/\\]?\d+)|(.*p[ \.]? ?(o|0)[-. \/\\]? *-?((box|bin)|b|(#|num)?\d+))|(p(ost)? *(o(ff(ice)?)?)? *((box|bin)|b)? *\d+)|(p *-?\/?(o)? *-?box)|post office box|((box|bin)|b) *(number|num|#)? *\d+|(num|number|#) *\d+)/i; // Check if address input is in the correct ASCII Range

export var RE_POSTAL_CODE = /^\d{5}(-\d{4})?$/; // Check if address input is in the correct ASCII Range

export var ASCII_AUDIT_RANGE = /^[\u0020-\u007E]+$/;

var getError = function getError(value, error) {
  if (!value && !_.isNumber(value)) {
    return error;
  }

  return undefined;
};

var getRequiredError = function getRequiredError(value) {
  return getError(value, ErrorType.Required);
};

var getInvalidError = function getInvalidError(value) {
  return getError(value, ErrorType.Invalid);
};

var getMismatchError = function getMismatchError(value) {
  return getError(value, ErrorType.Mismatch);
};

var getEmailError = function getEmailError(value) {
  return getRequiredError(value) || getInvalidError(value && RE_EMAIL.test(value));
};

var getInvalidLengthError = function getInvalidLengthError(value) {
  return getError(value, ErrorType.InvalidLength);
}; // USPS Address Verification using new backend REST endpoint


var uspsVerification =
/*#__PURE__*/
function () {
  var _ref = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee(address, tradingApiUrl, apiToken) {
    var address1, address2, city, state, postalCode, country, queryParams, queryString, headers, response, jsonResult, errorDescription, payload, zip5, zip4, zipParts;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            address1 = address.address1, address2 = address.address2, city = address.city, state = address.state, postalCode = address.postalCode, country = address.country; // If address has been provided, excluding postal code, and country is US, then perform USPS verification

            _context.prev = 1;

            if (!(address1 && city && state && country === Country.UnitedStatesOfAmerica && state !== StateEnum.PuertoRico)) {
              _context.next = 32;
              break;
            }

            if (apiToken) {
              _context.next = 6;
              break;
            }

            console.warn('USPS verification skipped: API token not provided');
            return _context.abrupt("return");

          case 6:
            // Build query parameters with %20 encoding for spaces
            queryParams = [];
            queryParams.push("address1=".concat(encodeURIComponent((address1 || '').trim())));
            queryParams.push("city=".concat(encodeURIComponent((city || '').trim())));
            queryParams.push("state=".concat(encodeURIComponent((state || '').trim()))); // Add address2 if provided

            if (address2) {
              queryParams.push("address2=".concat(encodeURIComponent(address2.trim())));
            }

            queryString = queryParams.join('&'); // Build request headers - always include token (we've verified it exists above)

            headers = {
              'Content-Type': 'application/json',
              Accept: 'application/json',
              Authorization: apiToken
            };
            _context.next = 15;
            return fetch("".concat(tradingApiUrl, "/USPSAddress?").concat(queryString), {
              method: 'GET',
              headers: headers
            });

          case 15:
            response = _context.sent;

            if (response.ok) {
              _context.next = 18;
              break;
            }

            return _context.abrupt("return", {
              error: {
                number: response.status.toString(),
                source: 'HTTP',
                description: "We couldn't verify this address. Please check your information and try again."
              }
            });

          case 18:
            _context.next = 20;
            return response.json();

          case 20:
            jsonResult = _context.sent;

            if (!(jsonResult.ResponseCode !== 0)) {
              _context.next = 25;
              break;
            }

            // Handle different error response formats - use layman-friendly messages
            errorDescription = "We couldn't verify this address. Please check your information and try again.";

            if (jsonResult.Payload) {
              if (jsonResult.Payload.error) {
                errorDescription = jsonResult.Payload.error;
              } else if (typeof jsonResult.Payload === 'string') {
                errorDescription = jsonResult.Payload;
              } else if (jsonResult.Payload.description) {
                errorDescription = jsonResult.Payload.description;
              } else if (jsonResult.Payload.message) {
                errorDescription = jsonResult.Payload.message;
              }
            } else if (jsonResult.error) {
              errorDescription = typeof jsonResult.error === 'string' ? jsonResult.error : jsonResult.error.description || 'Address validation failed';
            } else if (jsonResult.message) {
              errorDescription = jsonResult.message;
            }

            return _context.abrupt("return", {
              error: {
                number: jsonResult.ResponseCode && jsonResult.ResponseCode.toString() || '0',
                source: 'USPS',
                description: errorDescription
              }
            });

          case 25:
            payload = jsonResult.Payload;

            if (payload) {
              _context.next = 28;
              break;
            }

            return _context.abrupt("return", {
              error: {
                number: '0',
                source: 'USPS',
                description: "We couldn't verify this address. Please try again."
              }
            });

          case 28:
            // Split postalCode into zip5 and zip4
            zip5 = '';
            zip4 = '';

            if (payload.postalCode) {
              zipParts = payload.postalCode.split('-');
              zip5 = zipParts[0] || '';
              zip4 = zipParts[1] || '';
            } // Return the standardized address components
            // Note: New API doesn't return address2 separately, so we set it to null


            return _context.abrupt("return", {
              city: payload.city || '',
              state: payload.state || '',
              zip5: zip5,
              zip4: zip4,
              uspsAddress1: payload.address1 || '',
              uspsAddress2: null,
              isPoBox: payload.isPoBox || false,
              isSecondaryInformationRequired: payload.isSecondaryInformationRequired || false,
              isSecondaryInformationNotRecognized: payload.isSecondaryInformationNotRecognized || false
            });

          case 32:
            _context.next = 38;
            break;

          case 34:
            _context.prev = 34;
            _context.t0 = _context["catch"](1);
            console.error('USPS verification error:', _context.t0);
            return _context.abrupt("return", {
              error: {
                number: '0',
                source: 'Network',
                description: _context.t0 instanceof Error ? _context.t0.message : 'Network error occurred'
              }
            });

          case 38:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1, 34]]);
  }));

  return function uspsVerification(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}(); // Function to get USPS response from storage


var getUspsResponseFromStorage = function getUspsResponseFromStorage(prefix) {
  var uspsResponseFromStorage = sessionStorage.getItem("".concat(prefix.split('.')[0], "UspsResponse"));
  return uspsResponseFromStorage && uspsResponseFromStorage !== 'undefined' ? uspsResponseFromStorage : null;
};
/**
 * Clears USPS sessionStorage for a specific address field id (e.g. beneficiaries[0].address).
 * Prevents stale verification from applying after edits or row reordering.
 */


export var clearUspsSessionStorageForAddressField = function clearUspsSessionStorageForAddressField(formFieldId) {
  if (typeof sessionStorage === 'undefined') {
    return;
  }

  var base = formFieldId.split('.')[0];

  if (!base) {
    return;
  }

  try {
    sessionStorage.removeItem("".concat(base, "UspsResponse"));
  } catch (e) {
    console.warn('[clearUspsSessionStorageForAddressField] removeItem failed', e);
  }
};
/**
 * Clears all beneficiary USPS cache entries (beneficiaries[n]UspsResponse) after
 * remove/reorder that would shift indices and leave stale data under wrong keys.
 */

export var clearAllBeneficiaryUspsSessionStorage = function clearAllBeneficiaryUspsSessionStorage() {
  if (typeof sessionStorage === 'undefined') {
    return;
  }

  try {
    var keys = [];

    for (var i = 0; i < sessionStorage.length; i++) {
      var k = sessionStorage.key(i);

      if (k && /^beneficiaries\[\d+\]UspsResponse$/.test(k)) {
        keys.push(k);
      }
    }

    keys.forEach(function (k) {
      return sessionStorage.removeItem(k);
    });
  } catch (e) {
    console.warn('[clearAllBeneficiaryUspsSessionStorage] failed', e);
  }
}; // Async function to handle USPS verification

var getUSPS =
/*#__PURE__*/
function () {
  var _ref2 = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee2(address, tradingApiUrl, apiToken) {
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return new Promise(function (resolve) {
              return setTimeout(resolve, 100);
            });

          case 2:
            _context2.next = 4;
            return uspsVerification(address, tradingApiUrl, apiToken);

          case 4:
            return _context2.abrupt("return", _context2.sent);

          case 5:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function getUSPS(_x4, _x5, _x6) {
    return _ref2.apply(this, arguments);
  };
}(); // Create a unique key for an address to use for caching


var createAddressKey = function createAddressKey(address) {
  var normalized = {
    address1: (address.address1 || '').trim().toUpperCase(),
    address2: (address.address2 || '').trim().toUpperCase(),
    city: (address.city || '').trim().toUpperCase(),
    state: (address.state || '').trim().toUpperCase(),
    country: (address.country || '').trim().toUpperCase()
  };
  return "".concat(normalized.address1, "|").concat(normalized.address2, "|").concat(normalized.city, "|").concat(normalized.state, "|").concat(normalized.country);
}; // In-memory cache for pending requests to prevent duplicate concurrent calls


var pendingRequests = new Map(); // Debounce timers map - keyed by address key

var debounceTimers = new Map(); // Debounce delay in milliseconds

var DEBOUNCE_DELAY = 500; // Exported function to trigger USPS verification independently for debounced validation
// This can be called from components with debounced validation

export var triggerUspsVerification =
/*#__PURE__*/
function () {
  var _ref3 = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee5(address, prefix, tradingApiUrl, apiToken) {
    var address1, address2, city, state, postalCode, country, _storageKey, _addressKey, _existingTimer, addressKey, storageKey, cachedResponse, cached, _existingTimer2, existingTimer, debouncedPromise;

    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            address1 = address.address1, address2 = address.address2, city = address.city, state = address.state, postalCode = address.postalCode, country = address.country; // Check if validation should run (US country, required fields present, not Puerto Rico)

            if (!(!address1 || !city || !state || country !== Country.UnitedStatesOfAmerica || state === StateEnum.PuertoRico)) {
              _context5.next = 7;
              break;
            }

            // Clear USPS storage if fields are cleared
            if (!address1 || !city) {
              // Handle both formats: with dot separator (Address.tsx) and without (validateAddress)
              _storageKey = prefix.endsWith('.') ? "".concat(prefix, "uspsResponse") : "".concat(prefix.split('.')[0], "UspsResponse");
              sessionStorage.setItem(_storageKey, 'undefined');
            } // Clear any pending debounce timer


            _addressKey = createAddressKey({
              address1: address1,
              address2: address2,
              city: city,
              state: state,
              country: country
            });
            _existingTimer = debounceTimers.get(_addressKey);

            if (_existingTimer) {
              clearTimeout(_existingTimer);
              debounceTimers.delete(_addressKey);
            }

            return _context5.abrupt("return", null);

          case 7:
            if (apiToken) {
              _context5.next = 10;
              break;
            }

            console.warn('USPS verification skipped: API token not provided');
            return _context5.abrupt("return", null);

          case 10:
            // Create address key for caching
            addressKey = createAddressKey({
              address1: address1,
              address2: address2,
              city: city,
              state: state,
              country: country
            }); // Check if we already have a cached result for this exact address

            storageKey = prefix.endsWith('.') ? "".concat(prefix, "uspsResponse") : "".concat(prefix.split('.')[0], "UspsResponse");
            cachedResponse = sessionStorage.getItem(storageKey);

            if (!(cachedResponse && cachedResponse !== 'undefined')) {
              _context5.next = 24;
              break;
            }

            _context5.prev = 14;
            cached = JSON.parse(cachedResponse); // Check if cached result includes the address key or matches the current address

            if (!(cached.addressKey === addressKey || cached.uspsAddress1 && cached.uspsAddress1.toUpperCase() === (address1 || '').trim().toUpperCase() && cached.city && cached.city.toUpperCase() === (city || '').trim().toUpperCase() && cached.state && cached.state.toUpperCase() === (state || '').trim().toUpperCase())) {
              _context5.next = 20;
              break;
            }

            // We have a valid cached result for this address - return it without making API call
            // Clear any pending debounce timer since we have a cached result
            _existingTimer2 = debounceTimers.get(addressKey);

            if (_existingTimer2) {
              clearTimeout(_existingTimer2);
              debounceTimers.delete(addressKey);
            }

            return _context5.abrupt("return", cached);

          case 20:
            _context5.next = 24;
            break;

          case 22:
            _context5.prev = 22;
            _context5.t0 = _context5["catch"](14);

          case 24:
            if (!pendingRequests.has(addressKey)) {
              _context5.next = 26;
              break;
            }

            return _context5.abrupt("return", pendingRequests.get(addressKey));

          case 26:
            // Clear any existing debounce timer for this address
            existingTimer = debounceTimers.get(addressKey);

            if (existingTimer) {
              clearTimeout(existingTimer);
            } // Create a promise that will resolve after debounce delay


            debouncedPromise = new Promise(function (resolve) {
              var timer = setTimeout(
              /*#__PURE__*/
              _asyncToGenerator(
              /*#__PURE__*/
              _regeneratorRuntime.mark(function _callee4() {
                var requestPromise;
                return _regeneratorRuntime.wrap(function _callee4$(_context4) {
                  while (1) {
                    switch (_context4.prev = _context4.next) {
                      case 0:
                        // Remove timer from map
                        debounceTimers.delete(addressKey); // Now actually make the API call

                        requestPromise = _asyncToGenerator(
                        /*#__PURE__*/
                        _regeneratorRuntime.mark(function _callee3() {
                          var addressModel, result, resultWithKey;
                          return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                            while (1) {
                              switch (_context3.prev = _context3.next) {
                                case 0:
                                  _context3.prev = 0;
                                  addressModel = {
                                    address1: address1 || '',
                                    address2: address2 || '',
                                    city: city || '',
                                    state: state || '',
                                    postalCode: postalCode || '',
                                    country: country || ''
                                  };
                                  _context3.next = 4;
                                  return uspsVerification(addressModel, tradingApiUrl, apiToken);

                                case 4:
                                  result = _context3.sent;

                                  if (!result) {
                                    _context3.next = 9;
                                    break;
                                  }

                                  // Store the address key with the result for future comparison
                                  resultWithKey = Object.assign({}, result, {
                                    addressKey: addressKey
                                  }); // Store result in sessionStorage

                                  sessionStorage.setItem(storageKey, JSON.stringify(resultWithKey));
                                  return _context3.abrupt("return", resultWithKey);

                                case 9:
                                  return _context3.abrupt("return", result);

                                case 12:
                                  _context3.prev = 12;
                                  _context3.t0 = _context3["catch"](0);
                                  console.error(_context3.t0);
                                  return _context3.abrupt("return", null);

                                case 16:
                                  _context3.prev = 16;
                                  // Remove from pending requests after completion
                                  pendingRequests.delete(addressKey);
                                  return _context3.finish(16);

                                case 19:
                                case "end":
                                  return _context3.stop();
                              }
                            }
                          }, _callee3, null, [[0, 12, 16, 19]]);
                        }))(); // Store the pending request

                        pendingRequests.set(addressKey, requestPromise); // Resolve with the request promise

                        resolve(requestPromise);

                      case 4:
                      case "end":
                        return _context4.stop();
                    }
                  }
                }, _callee4);
              })), DEBOUNCE_DELAY); // Store the debounce timer

              debounceTimers.set(addressKey, timer);
            });
            return _context5.abrupt("return", debouncedPromise);

          case 30:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5, null, [[14, 22]]);
  }));

  return function triggerUspsVerification(_x7, _x8, _x9, _x10) {
    return _ref3.apply(this, arguments);
  };
}(); // Function to validate the address using the USPS response

var validateWithUspsResponse = function validateWithUspsResponse(uspsResponse, address, prefix, tradingApiUrl, apiToken) {
  var isTrustedContactAddress = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
  var isValidAddress = false;
  var uspsResponseValue; // Destructuring address object to get individual address components

  var address1 = address.address1,
      address2 = address.address2,
      city = address.city,
      state = address.state,
      country = address.country;

  if (state === StateEnum.PuertoRico) {
    return {};
  } // Check if a USPS response exists and is not 'undefined'


  if (uspsResponse && uspsResponse !== 'undefined') {
    // Parse the USPS response
    uspsResponseValue = JSON.parse(uspsResponse); // Extract relevant data from the parsed USPS response

    var _uspsResponseValue = uspsResponseValue,
        _city = _uspsResponseValue.city,
        _state = _uspsResponseValue.state,
        zip5 = _uspsResponseValue.zip5,
        error = _uspsResponseValue.error,
        uspsAddress1 = _uspsResponseValue.uspsAddress1,
        uspsAddress2 = _uspsResponseValue.uspsAddress2,
        isPoBox = _uspsResponseValue.isPoBox,
        isSecondaryInformationRequired = _uspsResponseValue.isSecondaryInformationRequired,
        isSecondaryInformationNotRecognized = _uspsResponseValue.isSecondaryInformationNotRecognized; // Check PO Box restriction (unless it's a trusted contact address)

    if (isPoBox && !isTrustedContactAddress) {
      isValidAddress = false; // PO Box addresses are not valid for non-trusted contact addresses
    } // Format the city name for comparison


    var formattedCityCapitalized = _.capitalize(_city);

    var startCaseCity = _.startCase(formattedCityCapitalized); // Compare each component of the address with the USPS response


    var isCityEqual = _.toLower(startCaseCity) === _.toLower(address.city); // Extract zip5 from postalCode (handle zip+4 format like "60606-6604")


    var userZip5 = address.postalCode ? address.postalCode.split('-')[0].trim() : '';
    var isZipEqual = zip5 === userZip5;
    var isStateEqual = _state === address.state; // Normalize addresses for comparison (trim, uppercase, normalize whitespace)

    var normalizeAddress = function normalizeAddress(addr) {
      if (!addr) return '';
      return addr.trim().replace(/\s+/g, ' ').toUpperCase();
    };

    var normalizedUspsAddress1 = normalizeAddress(uspsAddress1);
    var normalizedUserAddress1 = normalizeAddress(address.address1);
    var normalizedUspsAddress2 = normalizeAddress(uspsAddress2);
    var normalizedUserAddress2 = normalizeAddress(address.address2); // Since Smarty doesn't return address2 separately, only validate address1
    // Address2 validation is optional - if Smarty doesn't have it, don't fail validation

    var isAddressEqual = normalizedUspsAddress1 === normalizedUserAddress1 && (!normalizedUspsAddress2 || normalizedUspsAddress2 === normalizedUserAddress2);
    var isAddressCorrect = !error && isCityEqual && isZipEqual && isStateEqual && isAddressEqual; // Set the flag based on the address comparison results

    isValidAddress = isAddressCorrect;
  } // Clear USPS storage if address fields are cleared


  if (!address1 || !city) {
    sessionStorage.setItem("".concat(prefix.split('.')[0], "UspsResponse"), 'undefined');
  } // If address has been provided, excluding postal code, country is US but the current address is not valid, then perform USPS verification to retrieve valid address items or errors


  if (address1 && city && state && country === Country.UnitedStatesOfAmerica && !isValidAddress || address1 && address2 && city && state && country === Country.UnitedStatesOfAmerica && !isValidAddress) {
    // Set USPS Verification result to sessionStorage
    getUSPS(address, tradingApiUrl, apiToken).then(function (result) {
      sessionStorage.setItem("".concat(prefix.split('.')[0], "UspsResponse"), JSON.stringify(result));
      uspsResponseValue = result;
    });
  }

  if (uspsResponseValue && address.country === Country.UnitedStatesOfAmerica) {
    var _uspsResponseValue2 = uspsResponseValue,
        _city2 = _uspsResponseValue2.city,
        _state2 = _uspsResponseValue2.state,
        _zip = _uspsResponseValue2.zip5,
        _error = _uspsResponseValue2.error,
        _uspsAddress = _uspsResponseValue2.uspsAddress1,
        _uspsAddress2 = _uspsResponseValue2.uspsAddress2,
        _isPoBox = _uspsResponseValue2.isPoBox,
        _isSecondaryInformationRequired = _uspsResponseValue2.isSecondaryInformationRequired,
        _isSecondaryInformationNotRecognized = _uspsResponseValue2.isSecondaryInformationNotRecognized;

    if (_error && address.address1 && address.city && address.state && address.postalCode) {
      var _ref6;

      return _ref6 = {}, _defineProperty(_ref6, "".concat(prefix, "postalCode"), "".concat(_error.description.trim(), " Please review the entered address.")), _defineProperty(_ref6, "".concat(prefix, "city"), "".concat(_error.description.trim(), " Please review the entered address.")), _defineProperty(_ref6, "".concat(prefix, "state"), "".concat(_error.description.trim(), " Please review the entered address.")), _defineProperty(_ref6, "".concat(prefix, "address1"), "".concat(_error.description.trim(), " Please review the entered address.")), _ref6;
    }

    if (!address.address1 || !address.city) {
      sessionStorage.setItem("".concat(prefix.split('.')[0], "UspsResponse"), 'undefined');
    }

    if (_city2 && _state2 && _zip) {
      // Formatting for error message display of USPS response
      var _formattedCityCapitalized = _.capitalize(_city2);

      var _startCaseCity = _.startCase(_formattedCityCapitalized);

      var _isCityEqual = _.toLower(_startCaseCity) === _.toLower(address.city); // Extract zip5 from postalCode (handle zip+4 format like "60606-6604")


      var _userZip = address.postalCode ? address.postalCode.split('-')[0].trim() : '';

      var _isZipEqual = _zip === _userZip;

      var _isStateEqual = _state2 === address.state; // Normalize addresses for comparison (trim, uppercase, normalize whitespace)


      var _normalizeAddress = function _normalizeAddress(addr) {
        if (!addr) return '';
        return addr.trim().replace(/\s+/g, ' ').toUpperCase();
      };

      var _normalizedUspsAddress = _normalizeAddress(_uspsAddress);

      var _normalizedUserAddress = _normalizeAddress(address.address1);

      var _normalizedUspsAddress2 = _normalizeAddress(_uspsAddress2);

      var _normalizedUserAddress2 = _normalizeAddress(address.address2);

      var isAddress1Equal = _normalizedUspsAddress === _normalizedUserAddress; // Since Smarty doesn't return address2 separately, only validate if both exist
      // If Smarty doesn't have address2, don't validate user's address2

      var isAddress2Equal = _normalizedUspsAddress2 ? _normalizedUspsAddress2 === _normalizedUserAddress2 : true;

      var formattedAddress1 = _uspsAddress.toLowerCase().split(' ').map(function (s) {
        return s.charAt(0).toUpperCase() + s.substring(1);
      }).join(' ');

      var formattedAddress2 = _uspsAddress2 ? _uspsAddress2.toLowerCase().split(' ').map(function (s) {
        return s.charAt(0).toUpperCase() + s.substring(1);
      }).join(' ') : null; // Required Errors

      if (!address.postalCode) {
        return _defineProperty({}, "".concat(prefix, "postalCode"), getRequiredError(address.postalCode));
      }

      if (!address.city) {
        return _defineProperty({}, "".concat(prefix, "city"), getRequiredError(address.city));
      } // USPS Verification Errors


      var errors = {}; // PO Box validation - if Smarty identifies this as a PO Box, show error

      if (_isPoBox && !isTrustedContactAddress) {
        errors = Object.assign({}, errors, _defineProperty({}, "".concat(prefix, "address1"), 'PO Box addresses are not allowed for this address type.'));
      } // Secondary information (address2) required validation


      if (_isSecondaryInformationRequired && !address.address2) {
        errors = Object.assign({}, errors, _defineProperty({}, "".concat(prefix, "address2"), 'Secondary address information (apartment, suite, etc.) is required for this address.'));
      } // Secondary information not recognized warning


      if (_isSecondaryInformationNotRecognized && address.address2) {
        errors = Object.assign({}, errors, _defineProperty({}, "".concat(prefix, "address2"), 'The secondary address information provided was not recognized. Please verify or remove it.'));
      }

      if (!_isCityEqual) {
        errors = Object.assign({}, errors, _defineProperty({}, "".concat(prefix, "city"), "Please verify city. USPS Provided City: ".concat(_startCaseCity)));
      }

      if (!_isZipEqual) {
        errors = Object.assign({}, errors, _defineProperty({}, "".concat(prefix, "postalCode"), "Please verify the zip code. USPS Provided Zip Code: ".concat(_zip)));
      }

      if (!_isStateEqual) {
        errors = Object.assign({}, errors, _defineProperty({}, "".concat(prefix, "state"), "Please verify the state. USPS Provided State: ".concat(_state2)));
      } // Only show address1 error if we haven't already shown a more specific error above


      if (!isAddress1Equal && !errors["".concat(prefix, "address1")]) {
        errors = Object.assign({}, errors, _defineProperty({}, "".concat(prefix, "address1"), "Please utilize the USPS provided formatting: ".concat(formattedAddress1)));
      }

      if (_normalizedUspsAddress2 && !isAddress2Equal) {
        errors = Object.assign({}, errors, _defineProperty({}, "".concat(prefix, "address2"), "Please utilize the USPS provided formatting: ".concat(formattedAddress2)));
      }

      return errors;
    }
  }
};

export var validateAddress = function validateAddress(address, tradingApiUrl, apiToken, field) {
  var prefix = "".concat(field || 'address', ".");

  var isMailing = _.toLower(prefix).includes('mailing');

  var stateOrPostalCodeRequired = address.country === Country.UnitedStatesOfAmerica;
  var isTrustedContactAddress = field && field.toLowerCase().includes('trustedcontact');
  var uspsResponseFromStorage = getUspsResponseFromStorage(prefix.split('.')[0]);
  var uspsValidationErrors = validateWithUspsResponse(uspsResponseFromStorage, address, prefix, tradingApiUrl, apiToken, isTrustedContactAddress);

  if (Object.keys(uspsValidationErrors || {}).length > 0) {
    return uspsValidationErrors || {};
  }

  if (!isMailing) {
    var _errors;

    var errors = (_errors = {}, _defineProperty(_errors, "".concat(prefix, "country"), getRequiredError(address.country)), _defineProperty(_errors, "".concat(prefix, "address1"), getRequiredError(address.address1) || !isTrustedContactAddress && getInvalidError(!RE_PO_BOX.test(address.address1)) || getInvalidError(ASCII_AUDIT_RANGE.test(address.address1)) || getInvalidLengthError(address.address1.length <= 30) || address.address1 && getInvalidError(_.trim(address.address1) !== '')), _defineProperty(_errors, "".concat(prefix, "postalCode"), getRequiredError(stateOrPostalCodeRequired ? address.postalCode : true) || getInvalidError(stateOrPostalCodeRequired ? RE_POSTAL_CODE.test(address.postalCode) : true)), _defineProperty(_errors, "".concat(prefix, "city"), getRequiredError(address.city)), _defineProperty(_errors, "".concat(prefix, "state"), getRequiredError(stateOrPostalCodeRequired ? address.state : true)), _errors); // Only validate address2 if it has a value

    if (address.address2 && address.address2.trim() !== '') {
      errors["".concat(prefix, "address2")] = !isTrustedContactAddress && getInvalidError(!RE_PO_BOX.test(address.address2)) || getInvalidError(ASCII_AUDIT_RANGE.test(address.address2)) || getInvalidLengthError(address.address2.length <= 30) || getInvalidError(_.trim(address.address2) !== '');
    } // Remove any undefined errors


    Object.keys(errors).forEach(function (key) {
      return errors[key] === undefined && delete errors[key];
    });
    return errors;
  } else if (isMailing) {
    var _errors3;

    var _errors2 = (_errors3 = {}, _defineProperty(_errors3, "".concat(prefix, "country"), getRequiredError(address.country)), _defineProperty(_errors3, "".concat(prefix, "address1"), getRequiredError(address.address1) || address.address1 && getInvalidError(_.trim(address.address1) !== '')), _defineProperty(_errors3, "".concat(prefix, "postalCode"), getRequiredError(stateOrPostalCodeRequired ? address.postalCode : true)), _defineProperty(_errors3, "".concat(prefix, "city"), getRequiredError(address.city)), _defineProperty(_errors3, "".concat(prefix, "state"), getRequiredError(stateOrPostalCodeRequired ? address.state : true)), _errors3); // Only validate address2 if it has a value


    if (address.address2 && address.address2.trim() !== '') {
      _errors2["".concat(prefix, "address2")] = getInvalidError(_.trim(address.address2) !== '');
    } // Remove any undefined errors


    Object.keys(_errors2).forEach(function (key) {
      return _errors2[key] === undefined && delete _errors2[key];
    });
    return _errors2;
  }
};

var validatePhoneNumber = function validatePhoneNumber(value) {
  // Correct the regex pattern to allow multiple digits, underscores, and hyphens
  var regex = /^[0-9_-]+$/; // Check if the value matches the regex and if its length (not including "-") is greater than 10

  return regex.test(value) && value.replace(/-/g, '').length >= 10;
};

export var validateTrustedContactFields = function validateTrustedContactFields(values, tradingApiUrl, apiToken) {
  var isDevelopmentEnv = process.env.REACT_APP_ENVIRONMENT === 'dev';
  return Object.assign({
    'trustedContact.firstName': getRequiredError(values.trustedContact.firstName) || getInvalidError(isDevelopmentEnv ? RE_VALID_FIRST_NAME_WITH_NUMBERS.test(values.trustedContact.firstName) : RE_VALID_FIRST_NAME.test(values.trustedContact.firstName)) || getInvalidLengthError(values.trustedContact.firstName.length <= 20),
    'trustedContact.lastName': getRequiredError(values.trustedContact.lastName) || getInvalidError(isDevelopmentEnv ? RE_VALID_TRUSTED_CONTACT_LAST_NAME_WITH_NUMBERS.test(values.trustedContact.lastName) : RE_VALID_TRUSTED_CONTACT_LAST_NAME.test(values.trustedContact.lastName)) || getInvalidLengthError(values.trustedContact.lastName.length <= 20)
  }, validateAddress(values.trustedContact.address, tradingApiUrl, apiToken, 'trustedContact.address'), {
    'trustedContact.email': getEmailError(values.trustedContact.email),
    'trustedContact.phones[0].phoneNumber': getRequiredError(values.trustedContact.phones[0].phoneNumber) || getInvalidError(validatePhoneNumber(values.trustedContact.phones[0].phoneNumber))
  });
};
export var validateBeneficiaryPercentages = function validateBeneficiaryPercentages(beneficiaries) {
  var primaryBeneficiaries = beneficiaries.filter(function (b) {
    return b.beneficiaryAccountType === BeneficiaryAccountType.Primary;
  });
  var contingentBeneficiaries = beneficiaries.filter(function (b) {
    return b.beneficiaryAccountType === BeneficiaryAccountType.Contingent;
  });

  var totalPrimaryPercent = _.sumBy(primaryBeneficiaries, function (b) {
    return _.toNumber(b.percent);
  });

  var totalContingentPercent = _.sumBy(contingentBeneficiaries, function (b) {
    return _.toNumber(b.percent);
  });

  var errors = {}; // Block any contingent beneficiaries if no primary exists

  if (contingentBeneficiaries.length > 0) {
    if (primaryBeneficiaries.length === 0) {
      errors['beneficiaries[0].beneficiaryAccountType'] = 'At least one primary beneficiary is required before adding contingent beneficiaries.';
      errors['beneficiaries[0].percent'] = 'At least one primary beneficiary is required before adding contingent beneficiaries.';
      return errors;
    }

    if (totalPrimaryPercent !== 100) {
      primaryBeneficiaries.forEach(function (b, i) {
        var index = beneficiaries.indexOf(b);
        errors["beneficiaries[".concat(index, "].percent")] = 'Primary beneficiaries must total 100%.';
      });
      return errors;
    }

    if (totalContingentPercent !== 100) {
      contingentBeneficiaries.forEach(function (b, i) {
        var index = beneficiaries.indexOf(b);
        errors["beneficiaries[".concat(index, "].percent")] = 'Contingent beneficiaries must total 100%.';
      });
      return errors;
    }
  } // Validate primary percentages


  if (primaryBeneficiaries.length > 0) {
    if (totalPrimaryPercent > 100) {
      primaryBeneficiaries.forEach(function (b) {
        var index = beneficiaries.indexOf(b);
        errors["beneficiaries[".concat(index, "].percent")] = 'Primary beneficiaries cannot exceed 100%.';
      });
    } else if (totalPrimaryPercent < 100 && primaryBeneficiaries.length > 0) {
      primaryBeneficiaries.forEach(function (b) {
        var index = beneficiaries.indexOf(b);
        errors["beneficiaries[".concat(index, "].percent")] = 'Primary beneficiaries must total 100%.';
      });
    }
  }

  return errors;
};
export var validateTwoFactorAuthenticationSecurityCode = function validateTwoFactorAuthenticationSecurityCode(securityCodeString) {
  if (/^\d{6}$/.test(securityCodeString)) {
    return true;
  }

  return false;
};